// eslint-disable-next-line
import fetch from 'request-promise';

//eslint-disable-line
function slugify(string) {
  const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
  const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnooooooooprrsssssttuuuuuuuuuwxyyzzz------'
  const p = new RegExp(a.split('').join('|'), 'g')
  return string.toString().toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with 'and'
    //eslint-disable-next-line
    .replace(/[^\w\-]+/g, '') // Remove all non-word characters
    //eslint-disable-next-line
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
}

const fetchData = (state, action, dispatch) =>{
    /* GET DATA SET */
    const host = window.location.hostname;
    let client = slugify(host);
    let is_local = client ==="localhost"? true : false;
       client = is_local? 'quintasteakhousecom': client;
       client = client.replace("-","");
       /* Get dataset from body data-site */
        const data_site = document.body.dataset.site;
        client = data_site? data_site : client;
        const root = `https://weyoopos.firebaseio.com/public/${client}.json`;
        fetch(root).then(dat =>{
            let data = JSON.parse(dat);
            if(data !==null){
                data.client = client;
                /* WE LOAD SITE DATA, NOW LOAD SITE CONFIG */
                fetch(`https://file.garciatech.com/json/${client}.json`).then(dat =>{
                    data.settings.site = JSON.parse(dat);
                    dispatch({type:"FETCHED_SUCCESS",data});
                }).catch((err)=>{
                    data.settings.site = {
                        form:1,
                        status:1,
                        cellphone:""
                    }
                    dispatch({type:"FETCHED_SUCCESS",data});
                });
            }else{
                dispatch({type:"FETCHED_SUCCESS",data: null});
            } 
        });  
      
  return state;
}
const validateNumber = (number)=>{
   if(isNaN(Number(number))){
      return 0;
   }else{
      return Number(number);
   }
  
}
const getSubtotalByMods = (mods, item_price)=>{
    let subtotal = validateNumber(item_price);
    if(typeof mods ==="object"){
        Object.keys(mods).map(item =>{
            const mod = mods[item];
            Object.keys(mod).map(i =>{
                subtotal = subtotal + validateNumber(mod[i][2]);
                return null;
            });
            return null;
        })
    }
    return subtotal.toFixed(2);
}
const todos = (state = {}, action) => {
    switch (action.type) {
      case 'ADD_TO_ITEM':
          let cart_item = action.cart_item;
          let modal  = state.modal;
              modal.subtotal = getSubtotalByMods(cart_item.mods, modal.price);
          return {...state, cart_item };
      case 'ADD_TO_CART':
          return {...state, cart: action.item }
      case 'TOGGLE_MODAL':
          return {...state, modal: action.modal}
      case 'FETCH_DATA':
          return fetchData(state, action, action.dispatch);
      case 'FETCHED_SUCCESS':
        return {...state, modal:{}, app:action.data, fetched: true};
      default:
        return state
    } 
  }
  
  export default todos


// WEBPACK FOOTER //
// ./src/reducers/index.js